export default "__VITE_ASSET__BrxZ4wda__"